import {CurrentUserClass} from '../shared/CurrentUser';
import defineSection from '~/spa/section';
import {getWikiChildren} from '../wiki_page/WikiChildrenPages';
import {ROUTER_NAME_PREFIX_MY, ROUTER_NAME_PREFIX_USERS} from './config';

const MAIN_PREFIX = '/users/';

const PROFILE_PAGE_CIRCLE_CHILDREN = [
    {
        name: 'usersDetailPage-circle',
        path: 'list',
        component: () => import(/* webpackChunkName: "profile" */ './UserProfilePageCircleUsersList.vue'),
        props: true,
        meta: {name: 'list'}
    },
    {
        name: 'usersDetailPage-manageAccess',
        path: 'manage-access',
        component: () => import(/* webpackChunkName: "profile" */ './UserProfilePageCircleUsersManageAccess.vue'),
        props: true,
        meta: {name: 'manage-access'}
    },
    {
        name: 'usersDetailPage-pendingInvites',
        path: 'pending-invites',
        component: () => import(/* webpackChunkName: "profile" */ './UserProfilePageCircleUsersPendingInvites.vue'),
        props: true,
        meta: {name: 'invites'}
    },
];

const PROFILE_PAGE_CHILDREN = [
    {
        name: 'usersDetailPage-activity',
        path: 'activity',
        component: () => import(/* webpackChunkName: "profile" */ './UserProfilePageActivityUsers.vue'),
        props: true,
        meta: {name: 'activity'}
    },
    {
        name: 'usersDetailPage-stories',
        path: 'stories',
        component: () => import(/* webpackChunkName: "profile" */ './UserProfilePageStoriesUsers.vue'),
        props: true,
        meta: {name: 'stories'}
    },
    {
        name: 'usersDetailPage-goals',
        path: 'goals',
        component: () => import(/* webpackChunkName: "profile" */ './UserProfilePageGoalsUsers.vue'),
        props: true,
        meta: {name: 'goals'}
    },
    {
        name: 'usersDetailPage-groups',
        path: 'groups',
        component: () => import(/* webpackChunkName: "profile" */ './UserProfilePageGroupsUsers.vue'),
        props: true,
        meta: {name: 'groups'}
    },
    {
        name: 'usersDetailPage-manage',
        path: 'manage',
        component: () => import(/* webpackChunkName: "profile" */ './ProfilePageMenuManageUser.vue'),
        props: true,
        meta: {name: 'manage'}
    },
    {
        name: 'usersDetailPage-profile',
        path: 'profile',
        component: () => import(/* webpackChunkName: "profile" */ './UserProfilePageProfileUsers.vue'),
        props: true,
        meta: {name: 'profile'}
    },
    {
        path: 'circle',
        component: () => import(/* webpackChunkName: "profile" */ './UserProfilePageCircleUsers.vue'),
        props: true,
        children: PROFILE_PAGE_CIRCLE_CHILDREN,
        meta: {name: 'circle'}
    },
    {
        name: 'usersDetailPage-wikiList',
        path: 'wiki/list/',
        component: () => import(/* webpackChunkName: "profile" */ './UserProfilePageWikiList'),
        props: true,
        meta: {name: 'wiki', isMy: false}
    },
    {
        name: 'usersDetailPage-wiki',
        path: 'wiki/:wikiId/',
        component: () => import(/* webpackChunkName: "profile" */ './UserProfilePageWiki.vue'),
        props: true,
        children: getWikiChildren(ROUTER_NAME_PREFIX_USERS, {isMy: false, name: 'wiki'}),
        meta: {name: 'wiki', isMy: false}
    },
    {
        name: 'usersDetailPage',
        path: '',
        component: () => import(/* webpackChunkName: "profile" */ './UserProfilePageLanding.vue'),
    },
];

const MY_PROFILE_PAGE_CHILDREN = [
    {
        name: 'myDetailPage-activity',
        path: 'activity',
        component: () => import(/* webpackChunkName: "profile" */ './UserProfilePageActivityMy.vue'),
        props: true,
        meta: {name: 'activity'}
    },
    {
        name: 'myDetailPage-feed',
        path: 'feed',
        component: () => import(/* webpackChunkName: "profile" */ './UserProfilePageFeedMy.vue'),
        props: true,
        meta: {name: 'feed'}
    },
    {
        name: 'myDetailPage-stories',
        path: 'stories',
        component: () => import(/* webpackChunkName: "profile" */ './UserProfilePageStoriesMy.vue'),
        props: true,
        meta: {name: 'stories'}
    },
    {
        name: 'myDetailPage-goals',
        path: 'goals',
        component: () => import(/* webpackChunkName: "profile" */ './UserProfilePageGoalsMy.vue'),
        props: true,
        meta: {name: 'goals'}
    },
    {
        name: 'myDetailPage-tasks',
        path: 'tasks',
        component: () => import(/* webpackChunkName: "profile" */ './UserProfilePageGoalsTasksMy.vue'),
        props: true,
        meta: {name: 'tasks'}
    },
    {
        name: 'myDetailPage-profile',
        path: 'profile',
        component: () => import(/* webpackChunkName: "profile" */ './UserProfilePageProfileMy.vue'),
        props: true,
        meta: {name: 'profile'}
    },
    {
        name: 'myDetailPage-circle',
        path: 'circle',
        component: () => import(/* webpackChunkName: "profile" */ './UserProfilePageCircleMy.vue'),
        props: true,
        meta: {name: 'circle'}
    },
    {
        name: 'myDetailPage-browseProfiles',
        path: 'search-users',
        component: () => import(/* webpackChunkName: "profile" */ './UserProfilePageBrowseProfiles.vue'),
        props: true,
        meta: {name: 'browseProfiles'}
    },
    {
        name: 'myDetailPage-communities',
        path: 'groups-and-communities',
        component: () => import(/* webpackChunkName: "profile" */ './UserProfilePageCommunitiesMy.vue'),
        props: true,
        meta: {name: 'communities'}
    },
    {
        name: 'myDetailPage-find-communities',
        path: 'find-communities',
        component: () => import(/* webpackChunkName: "profile" */ './UserProfilePageFindCommunities.vue'),
        props: true,
        meta: {name: 'find-communities'}
    },
    {
        name: 'myDetailPage-settings',
        path: 'settings',
        component: () => import(/* webpackChunkName: "profile" */ './UserProfilePageSettingsMy.vue'),
        props: true,
        meta: {name: 'settings'}
    },
    {
        name: 'myDetailPage-wikiList',
        path: 'wiki/list/',
        component: () => import(/* webpackChunkName: "profile" */ './UserProfilePageWikiList'),
        props: true,
        meta: {name: 'wiki', isMy: true}
    },
    {
        name: 'myDetailPage-wiki',
        path: 'wiki/:wikiId/',
        component: () => import(/* webpackChunkName: "profile" */ './UserProfilePageWiki.vue'),
        props: true,
        meta: {name: 'wiki', isMy: true},
        children: getWikiChildren(ROUTER_NAME_PREFIX_MY, {isMy: true, name: 'wiki'})
    },
    {name: 'myDetailPage', path: '', redirect: {name: 'myDetailPage-activity'}},
];

/**
 * Somebody's own profile is a different set of pages from somebody else's, so
 * asking for your own by name lands on the "my" half of the tree instead.
 *
 * This is registered on the shared router rather than on the section, because it
 * has to fire on every navigation within the section, not only on entering it.
 */
export const redirectOwnProfileToMyPages = (to, from, next) => {
    const CurrentUser = new CurrentUserClass();
    if (to.name && (to.name.indexOf('usersDetailPage') === 0) && (to.params.userName === CurrentUser.username || to.params.userName === 'me')) {
        // your own profile by name has always opened on the profile tab: the record
        // used to redirect to usersDetailPage-profile before this guard ever saw the
        // navigation. Now that it lands on a page instead, say so here - 'myDetailPage'
        // on its own would send you to your activity
        const name = to.name === 'usersDetailPage' ? 'myDetailPage-profile' : to.name.replace('usersDetailPage', 'myDetailPage');
        next({name});
    } else {
        next();
    }
};

export default defineSection({
    routes: [
        {
            path: MAIN_PREFIX + 'me/',
            component: () => import(/* webpackChunkName: "profile" */ './UserProfileMainPage'),
            children: MY_PROFILE_PAGE_CHILDREN,
        },
        {
            path: MAIN_PREFIX + ':userName/',
            component: () => import(/* webpackChunkName: "profile" */ './UserProfileMainPage'),
            props: true,
            children: PROFILE_PAGE_CHILDREN,
        },
    ]
});
